._loadCollectionsPlaceholder_otmj0_1 {
  height: 100%;
  text-align: left; }
  ._loadCollectionsPlaceholder_otmj0_1 ._collectionsListWrapper_otmj0_4,
  ._loadCollectionsPlaceholder_otmj0_1 ._applicationStatesWrapper_otmj0_5 {
    height: 100%; }

._loadCollectionsPlaceholderChildrenContainer_otmj0_8 {
  height: 100%; }
